import { render, staticRenderFns } from "./Complex.vue?vue&type=template&id=3ed1dcf8&scoped=true&"
import script from "./Complex.vue?vue&type=script&lang=js&"
export * from "./Complex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ed1dcf8",
  null
  
)

export default component.exports